import { OpenAiModal } from "./openAiModal";
import { FilterNodeModal } from "./filterNodeModal";
import { modelNodeModal } from "./modelNodeModal";
import { ManualTriggerModal } from "./manualTriggerModal";
import { ExcelExportNodeModal } from "./excelExportNodeModal";
import { AiAgentNodeModal } from "./aiAgentNodeModal";
import { TimeTriggerModal } from "./timeTriggerModal";
import { WordExportNodeModal } from "./wordExportNodeModal";

export const ModalTypes = {
  "tool.openai": OpenAiModal,
  "data.filter": FilterNodeModal,
  "data.model": modelNodeModal,
  "trigger.manual": ManualTriggerModal,
  "trigger.schedule": TimeTriggerModal, // Assuming ManualTriggerModal is used for schedule as well
  "data.exporttoexcel": ExcelExportNodeModal,
  "data.exporttoword": WordExportNodeModal, // Assuming Excel export is used for Word as well
  "ai.agent": AiAgentNodeModal,
};
